<div style="display: flex; justify-content: space-between; align-items: center;">
  <div style="text-align: left;">
    <img src="../../assets/images/Avalara.png"
         class="Header__Main__Logo__Primary"
         alt="Logo da sua aplicação">
  </div>
  <div style="text-align: center;"><h2>PARTNER PROJECT PORTAL</h2></div>
  <div style="text-align: right;"><h6>Usuário: {{ usuarioLogado }}<BR>Grupo: {{ grupoLogado }}</h6></div>
</div>

<div class="menubar-container">
    <div class="card">
      <p-menubar [model]="items">
        <ng-template pTemplate="end">
          <button
            pButton
            type="button"
            label="Sair"
            icon="pi pi-sign-out"
            class="p-button-secondary"
            (click)="logout()"
          ></button>
        </ng-template>
      </p-menubar>

    </div>

</div>
